export const GET_MENU_INFO = 'GET_MENU_INFO'

import MenuInfoApi from '../../../apis/menu_info'

export default {
  // eslint-disable-next-line no-unused-vars
  [GET_MENU_INFO]({ commit }, params) {
    return  MenuInfoApi.getInfoMenuDetail(
      params.menuNo,
      params.companyCd
    )
  }
}

